<template>
  <v-container fluid>
    <Window v-model="record_id" :ad_window_id="ad_window_id"></Window>
  </v-container>
</template>

<script>
import Window from "../components/Window.vue";
export default {
  components: { Window },
  data() {
    return {
      ad_window_id: 1000072,
      record_id: 0,
    };
  },
};
</script>

<style>
</style>